import { StructuredContentProvider } from '@nerdwallet/structured-content-core';
export default StructuredContentProvider;